import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as techApi from '../../lib/api/tech';

const [LIST_MID_TECHS, LIST_MID_TECHS_SUCCESS, LIST_MID_TECHS_FAILURE] =
    createRequestActionTypes('project/LIST_MID_TECHS');

export const listMidTechs = createAction(
    LIST_MID_TECHS,
    (searchData) => searchData,
);
const listMidTechsSaga = createRequestSaga(
    LIST_MID_TECHS,
    techApi.getMidTechs,
);

const UNLOAD_MIDS_TECHS = 'project/UNLOAD_MIDS_TECHS';
export const unloadMidTechs = createAction(UNLOAD_MIDS_TECHS);

export function* MidTechsSaga() {
    yield takeLatest(LIST_MID_TECHS, listMidTechsSaga);
}

const initialState = {
    techMids: [],
    techMidInfo: null,
    error: null,
};

const midTechs = handleActions(
    {
        [LIST_MID_TECHS_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            techMids: data.list.map((tech) => ({
                id: tech.rptUuid,
                rptUuid: tech.rptUuid,
                rptNo: tech.rptNo,
                reqUuid: tech.reqUuid,
                planUuid: tech.planUuid,
                prjUuid: tech.prjUuid,
                rptTitle: tech.rptTitle,
                rptTyp: tech.rptTyp,
                rptContext: tech.rptContext,
                rptStrtDt: tech.rptStrtDt,
                rptStrtTm: tech.rptStrtTm,
                rptEndDt: tech.rptEndDt,
                rptEndTm: tech.rptEndTm,
                rptTotTm: tech.rptTotTm,
                rptCostList: tech.rptCostList,
                rptCostTotVal: tech.rptCostTotVal,
                crtUsr: tech.crtUsr,
                crtNm: tech.crtNm,
                crtDt: tech.crtDt,
                cngUsr: tech.cngUsr,
                cngNm: tech.cngNm,
                cngDt: tech.cngDt,
            })),
            techMidInfo: data.info,
            error: null,
        }),
        [LIST_MID_TECHS_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error: error,
        }),
        [UNLOAD_MIDS_TECHS]: () => initialState,
    },
    initialState,
);

export default midTechs;
